<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :mask-closable="false"
    :width="616"
    wrap-class-name="edit-info-from-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p class="prompt">
      {{ $t('message[1721]').split('|')[0] }}<span class="fs-red">{{ $t('message[1721]').split('|')[1] }}</span>{{ $t('message[1721]').split('|')[2] }}
    </p>
    <a-form
      :form="form"
      :class="[$isEnglish ? 'isEnglish' : '']"
    >
      <my-item
        :value="currentFrom"
        :data="fromInfoData"
        class="clearfix"
        @change="handleChangeFromSource"
      >
        <p
          v-if="currentFrom && (fromInfoData.childObj[currentFrom].status === -7 || !fromInfoData.childObj[currentFrom].isenable)"
          slot
          class="fs-warn fs-12"
        >
          负责人修改了来源配置，请重新选择
        </p>
      </my-item>

      <template v-if="currentFrom && fromInfoData.childObj && fromInfoData.childObj[currentFrom]">
        <my-item
          v-for="(item) in fromInfoData.childObj[currentFrom].child"
          :id="item.fieldkey"
          :key="item.fieldkey"
          :data="item"
          :modules-data="fromInfoData"
          :current-from="currentFrom"
          class="clearfix"
          @change="handleChangeFromChild"
        >
          <p
            v-if="item.isConfigEdit"
            slot
            class="fs-warn fs-12"
          >
            负责人修改了来源配置，请重新选择
          </p>
        </my-item>
      </template>

      <my-cascader
        ref="devCascader"
        :value="currentDevValue"
        :data="devObj"
        :get-data="getData"
        @change="handleChangeDev"
      >
        <div
          v-if="relateTeamInfo.length"
          slot="relate-list"
          class="relate-list"
        >
          <p>{{ $t('message["1457"]') }}：</p>
          <a-radio-group
            v-model="relateValue"
            @change="onChangeRelate"
          >
            <a-radio
              v-for="info in relateTeamInfo"
              :key="`${info.roleid}-${info.groupid}-${info.userid}`"
              :value="info.id"
            >
              <span v-if="info.rolename">{{ info.rolename }}</span>
              <span v-if="info.groupname">/{{ info.groupname }}</span>
              <span v-if="info.truename">/{{ info.truename }}</span>
            </a-radio>
          </a-radio-group>
        </div>
      </my-cascader>
    </a-form>
  </a-modal>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import MyItem from './../../formItem/Item'
import MyCascader from './../../formItem/Cascader'
import { cloneDeep } from 'lodash'
import { setCodeData, debounce } from '@/lib/utils'
import { getEncode } from '@/lib/mix'
import { getAuthTeamInfo } from '@/services/index'
import { getLang } from '@/lib/storage'

export default {
  name: 'EditInfoModal',
  components: {
    MyItem,
    MyCascader
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      fromInfoData: {},
      devObj: {},
      copyDevObj: {},
      currentFrom: '',
      devResult: {},
      relateValue: '',
      currentDevValue: [],
      confirmLoading: false
    }
  },

  computed: {
    ...mapGetters('inquery/detailData', [
      'fromInfo',
      'memberInfo'
    ]),

    ...mapState('inquery/relateData', ['relateTeamInfo']),

    inquiryId () {
      return this.$route.params.inquiryId
    },

    isEnglish () {
      return this.getLang() === 'en'
    },

    title () {
      // 修改信息来源
      return this.$t('message["1720"]')
    }
  },

  watch: {
    visible (val) {
      if (!val) return
      this.init()
    },
    fromInfo: {
      handler (val) {
        if (!val) return
        this.initFromInfoData()
      },
      immediate: true,
      deep: true
    },
    memberInfo: {
      handler (val) {
        if (!val) return
        this.initMemberInfoData()
      },
      immediate: true,
      deep: true
    },
    // 来源关联人员
    relateTeamInfo: {
      handler (val) {
        if (val.length === 1) {
          this.devObj.info = val[0]
          this.devObj.fieldvalue = this.setDefaultValue(this.devObj)
          this.relateValue = val[0].id
          this.currentDevValue = this.devObj.fieldvalue
        } else if (val.length > 1) {
          this.devObj.info = {}
          this.devObj.fieldvalue = []
          this.relateValue = ''
          this.currentDevValue = []
        } else if (val.length === 0) {
          this.devObj.info = this.copyDevObj.info
          this.devObj.fieldvalue = this.setDefaultValue(this.copyDevObj)
          this.currentDevValue = this.copyDevObj.fieldvalue
          this.relateValue = ''
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('inquery/relateData', [
      'fetchRelateTeamInfo'
    ]),
    ...mapActions('inquery/detailData', [
      'editInquiryFromInfo'
    ]),
    ...mapMutations('inquery/relateData', ['SET_RELATE_LIST_DATA']),

    getLang,

    init () {
      this.initFromInfoData()
      this.initMemberInfoData()
    },

    initFromInfoData () {
      this.fromInfoData = cloneDeep(this.fromInfo)
      const { fieldvalue = '', child = [] } = this.fromInfoData || {}
      const currentItem = child.find(one => one.fieldkey === fieldvalue) || {}
      const currentKey = currentItem.fieldkey
      this.fromInfoData.oldfieldvalue = currentKey
      this.currentFrom = currentItem.id
      this.fromInfoData.fieldvalue = this.currentFrom
      this.fromInfoData.fieldname = this.fromInfoData.fromname

      for (let k in this.fromInfoData.childObj) {
        const item = this.fromInfoData.childObj[k]
        item.isedit = this.fromInfoData.isedit

        item.child = item.child.filter(child => child.status !== -7 && child.isenable)
        for (let i in item.child) {
          let one = item.child[i]
          one.isedit = this.fromInfoData.isedit
          one.options = one.options.filter(option => option.status !== -7)
          if (one.fieldtype === 'select' && one.fieldvalue && !one.options.find(option => option.id === one.fieldvalue)) {
            one.fieldvalue = undefined
            one.isConfigEdit = true
          }
        }
      }

      // 通过的详情，设置来源的下拉选项
      this.fromInfoData.options = child.filter(item => {
        // if (item.status !== -7 && item.isenable && item.child && item.child.length) {
        if (item.status !== -7 && item.isenable) {
          let obj = {
            id: item.id,
            name: item.fieldname
          }
          return obj
        }
      })
      if (!this.fromInfoData.options.find(item => item.id === this.currentFrom)) {
        this.fromInfoData.fieldvalue = undefined
      }

      this.$forceUpdate()

      // this.getRelateTeamInfo(this)
    },

    initMemberInfoData () { // 审核详情的人员信息
      const { childObj = {} } = this.memberInfo || {}
      const devData = childObj.dev || {}
      this.devObj = {
        ...devData,
        key: 'dev',
        fieldtype: 'cascader',
        fieldvalue: [],
        isneeded: 1
      }

      this.devObj.fieldvalue = this.setDefaultValue(this.devObj)
      this.copyDevObj = cloneDeep(this.devObj)
      this.currentDevValue = this.devObj.fieldvalue
    },

    /**
     * 切换信息来源：网站，电话，邮箱等
     */
    handleChangeFromSource (val) {
      if (!this.fromInfoData) return

      this.fromInfoData.fieldvalue = val
      this.currentFrom = val
      this.devObj.fieldvalue = []
      this.devObj.info = {}

      this.getRelateTeamInfo(this)
    },

    handleChangeFromChild (val) {
      if (!this.currentFrom) return
      this.fromInfoData.childObj[this.currentFrom].fieldvalue = val
      this.getRelateTeamInfo(this)
    },

    getRelateTeamInfo: debounce(async (_this) => {
      // 关联人员
      const { currentFrom = '' } = _this
      const { fieldkey = '', childObj = {} } = _this.fromInfoData

      if (fieldkey === 'from_info' && childObj[currentFrom]) {
        const { fieldkey = '', child } = childObj[currentFrom]
        let params = {}
        params.fieldkey = fieldkey
        params.fromkv = {}

        if (!child) return

        for (let k in child) {
          let item = child[k]
          params.fromkv[item.fieldkey] = item.fieldvalue || ''
        }

        try {
          let chain = await _this.fetchRelateTeamInfo()
          chain.params(params).fetch()
        } catch (error) {
          console.log(error)
        }
      }
    }, 1000),

    async getData (obj = {}) {
      let { fieldkey, type } = obj
      let params = {}
      let result
      if (type) { // 共享
        params.type = type
      }

      if (fieldkey === 'dev') { // 开发人员
        params.pk = 'inquiry-dev'
        params.deal = 1 // 去除空组和空团队

        result = await getAuthTeamInfo()
          .params(params).fetch()
      }

      let { payload: data = [] } = (result && result.data) || {}

      if (fieldkey === 'dev') {
        data = [{
          id: 'null',
          keyname: 'roleid',
          name: '-' + this.$t('message["1723"]') + '-' // -无-
        }].concat(data)
      }

      return data
    },

    /**
     * 当分配方式是包含1，选到人，不是包含1，删除掉人的 children 数据，divide_type是数组
     */
    setFollowData (data) {
      for (let item of data) {
        if (item.hasOwnProperty('divide_type') && item.divide_type.length === 1 && item.divide_type[0] !== 1) {
          item.children = []
        }
        if (item.children && item.children.length) {
          this.setFollowData(item.children)
        }
      }
    },

    handleChangeDev (val = {}) {
      this.relateValue = ''
      this.devObj.info = val.info
      this.copyDevObj.info = val.info
      this.copyDevObj.fieldvalue = val.fieldvalue
    },

    onChangeRelate (item) {
      this.relateTeamInfo.forEach(info => {
        if (info.id === this.relateValue) {
          item.fieldvalue = this.setDefaultValue({ info })
          item.info = info
          this.devObj.info = info
          this.currentDevValue = item.fieldvalue
        }
      })
    },

    /**
     * 处理默认value值
     */
    setDefaultValue (item = {}) {
      let arr = []
      const { info = {} } = item
      let { roleid = 0, groupid = 0, userid = 0, divide_type: divideType, type_num: typeNum } = info

      if (!roleid && !userid) {
        roleid = 'null'
      }
      if (roleid) {
        arr.push(`${roleid}-roleid`)
      }
      if (groupid) {
        arr.push(`${groupid}-groupid`)
      }
      // typeNum=2 四级
      if (typeNum) {
        if (divideType === 1 && typeNum === 2 && userid) {
          arr.push(`${divideType}-divide_type`)
          arr.push(`${userid}-userid`)
        } else if (userid && (!divideType || typeNum === 1)) {
          arr.push(`${userid}-userid`)
        } else if (divideType) {
          arr.push(`${divideType}-divide_type`)
        }
      } else {
        if (divideType === 1 && userid) {
          arr.push(`${divideType}-divide_type`)
          arr.push(`${userid}-userid`)
        } else if (userid && !divideType) {
          arr.push(`${userid}-userid`)
        } else if (divideType) {
          arr.push(`${divideType}-divide_type`)
        }
      }

      return arr
    },

    async setConfrimParams () {
      const enCode = await getEncode()
      let fromResult = {}
      let { fieldvalue = '', childObj = {} } = this.fromInfoData
      let children

      if (fieldvalue) {
        fromResult.from = childObj[fieldvalue] && childObj[fieldvalue].fieldkey
        children = childObj[fieldvalue] && childObj[fieldvalue].child
      } else {
        fromResult.from = this.fromInfoData.child[0] && this.fromInfoData.child[0].fieldkey
      }
      for (let k in children) {
        const item = children[k]
        const value = item.fieldvalue
        // text, editor, tag.*, number
        switch (item.fieldtype) {
          case 'text':
          case 'editor':
          case 'tag':
            fromResult[item.fieldkey] = await setCodeData(value, enCode)
            break
          default:
            fromResult[item.fieldkey] = value
            break
        }
      }

      let { info = {} } = this.devObj
      this.devResult.dev_roleid = info.roleid
      this.devResult.dev_groupid = info.groupid
      this.devResult.dev_userid = info.userid

      return {
        from_info: fromResult,
        info: this.devResult,
        inquiryid: this.inquiryId
      }
    },
    async handleOk () {
      this.$bus.$emit('myQuillEditorBlur')
      let params = await this.setConfrimParams()

      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return
          this.confirmLoading = true

          let chain = await this.editInquiryFromInfo(params)
          chain.onSuccess(res => {
            this.hide()
            this.confirmLoading = false
            this.$bus.$emit('fetchInquiryDetail')
            this.$router.push({
              query: {
                ...this.$route.query,
                tab1: 'inforFrom'
              }
            })
          })
        }
      })
    },
    handleCancel () {
      this.hide()
    },

    hide () {
      this.form.resetFields()
      // this.initFromInfoData()
      this.SET_RELATE_LIST_DATA([])
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style scoped lang="scss">
.prompt {
  height:40px;
  line-height: 40px;
  margin-bottom: 24px;
  padding: 0 24px;
  background:#FFF4E7;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 164px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 164px;
}
.relate-list ::v-deep {
  .ant-radio-wrapper {
    display: block;
  }
}
::v-deep .quill-editor {
  width: 380px;
}
.isEnglish ::v-deep {
  .ant-form-item-label{
    width: 194px;
  }
  .ant-form-item-control-wrapper {
    padding-left: 194px;
  }
}
</style>
<style lang="scss">
.edit-info-from-modal {
  .ant-modal-body {
    padding: 0;
    min-height: 300px;
    max-height: 468px;
    overflow-y: scroll;
  }
}
</style>
